<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Escalas de Horários</h5>
                <hr>

				<TabView>					
      				<TabPanel header="Escalas" class="p-mt-3">
						<Toolbar class="p-mb-4">
							<template slot="left">	
								<Button label="Nova" icon="pi pi-plus" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>				
							</template>
						</Toolbar>

						<DataTable :value="contratos" :filters="filtro" :paginator="true" :rows="10"
							paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
							:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
							class="p-datatable-sm p-datatable-striped">
							<template #header>
								<div class="table-header">			
									<div class="p-d-flex p-jc-end">				
										<span class="p-input-icon-left">
											<i class="pi pi-search" />
											<InputText v-model="filtro['global']" placeholder="Filtrar..." />
										</span>
									</div>
								</div>
							</template>
							<Column field="id" header="Id" sortable></Column>
							<Column field="descricao" header="Descrição" sortable></Column>
							<Column field="tipo" header="Tipo" sortable></Column>							
							<Column>
								<template #body="slotProps">															
									<Button @click="editar(slotProps.data)" v-if="permissaoEditar" title="Editar" icon="pi pi-pencil" class="p-button-rounded p-button-primary p-mr-2"/>
									<Button @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir" title="Excluir" icon="pi pi-trash" class="p-button-rounded p-button-danger"/>
								</template>
							</Column>
						</DataTable>
      				</TabPanel>
					  
					<TabPanel header="Funcionário/Escala" class="p-mt-3">
						<EditaFuncionario />
      				</TabPanel>
				</TabView>

                <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir escala <b>{{ contratoSelecionado.descricao }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>

			</div>
		</div>
  </div>
</template>

<script>
import EditaFuncionario from '@/components/pages/cadastro/escalas/EditaFuncionario';
import ConfiguracaoEscalaService from '@/service/ConfiguracaoEscalaService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	configuracaoEscalaService: null,
    data() {        
        return {           
            contratos: [],
            permissaoNovo: false,
            permissaoEditar: false,	
            permissaoExcluir: false,	
            exibirDialogConfirmarExcluir: false,
            contratoSelecionado: {},
            filtro: {},
        }
    }, 
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        novo() {
            this.$router.push('/cadastros/escalas-horarios/novo');
        },
        editar(contrato) {
			this.$router.push('/cadastros/escalas-horarios/'+contrato.id+'/editar');
        },
        excluir() {
			let requisicao = {
				idContrato: this.contratoSelecionado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			};			
			this.configuracaoEscalaService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
        },
        confirmarExcluir(contrato) {
            this.contratoSelecionado = contrato;
			this.exibirDialogConfirmarExcluir = true;
        },
        limparExcluir() {
			this.contratoSelecionado = {};
			this.exibirDialogConfirmarExcluir = false;
		},
        listar() {
            this.configuracaoEscalaService.listar({...this.getDadosRequisicao()})
				.then(resp => {			
					this.contratos = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(71);
            this.permissaoEditar = permissoes.includes(72);	
            this.permissaoExcluir = permissoes.includes(73);				
		}
    },
    created() {		
		this.configuracaoEscalaService = new ConfiguracaoEscalaService();
		// Após salvar/editar uma configuração de escala com sucesso.
		let uri = window.location.search.substring(1); 
		let params = new URLSearchParams(uri);
		if(typeof params.get("sc") !== 'undefined' && params.get("sc") === 't') {
			exibirMensagemSis(this, 'Sucesso', false);
		}
    },
    mounted() {		
		this.validarPermissoes();	
		this.listar();		
	},
	components: {
        'EditaFuncionario': EditaFuncionario      
    }
}
</script>

<style>

</style>